import React, { FunctionComponent, ReactElement } from "react";
import styled from "styled-components";
import Button, { StyledButton } from "../../common/Buttons/Button";
import useFormField from "../../common/Forms/useFormField";
import Textarea from "../../common/Forms/Textarea";
import { lengthBetweenValidation } from "../../common/Forms/validation";
import { CloseIssuesFormProps } from "./types";

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
`;

const StyledButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 22px;

  ${StyledButton} {
    width: 166px;
    max-width: none;
    margin-right: 18px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const CloseIssuesForm: FunctionComponent<CloseIssuesFormProps> = ({ cancelLabel, initialValues, onCancel, onSubmit, submitLabel }): ReactElement => {
  const [message, setMessage, clearMessage, validateMessage, messageError] = useFormField<string>(initialValues.message, [lengthBetweenValidation(1, 10000)]);

  const handleCancel = () => {
    onCancel();
    clearMessage();
  };

  const handleSubmit = () => {
    const errors = [validateMessage()];

    if (errors.filter(e => !!e).length === 0) {
      onSubmit({ message });
    }
  };

  return (
    <>
      <StyledForm>
        <Textarea placeholder="Write your note here" label="Your message" value={message} onChange={setMessage} error={messageError} />
      </StyledForm>
      <StyledButtons>
        <Button label={cancelLabel} theme="SUCCESS_SECONDARY" onClick={handleCancel}/>
        <Button icon="ok" label={submitLabel} theme="SUCCESS_PRIMARY" onClick={handleSubmit} />
      </StyledButtons>
    </>
  );
};

export default CloseIssuesForm;
